import SubcontractGoodReceipt from '@/models/SubcontractGoodReceipt/SubcontractGoodReceipt';

export default class SubcontractGoodReceiptFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.subcontractGoodReceiptNumber = '';
		this.subcontractRequestDeliveryId  = '';
		this.subcontractRequestDeliveryRequestDeliveryNumber = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.suratJalan = '';
		this.remarksMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			subcontractGoodReceiptNumber : '0',
			subcontractRequestDeliveryId : '0',
			subcontractRequestDeliveryRequestDeliveryNumber : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			suratJalan : '0',
			remarksMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}